// removed by extract-text-webpack-plugin
module.exports = {"storeCreditSummary":"_3ZFDpRcN2qCQUCeJAUvtkS","storeCreditSummary--box":"_3uMdjk_0tiCHL4lFXF2Ewu","storeCreditSummary--currency":"_3THtlmXxCbFGFExV8dw9Sk","continueShopping":"_9YO37hHWVPbulVAPHxgOJ"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/StoreCreditSummary/style.scss
// module id = 985
// module chunks = 0